
import { Component, EventEmitter, Output , OnInit} from '@angular/core';
import { Idioma } from '../../domain/Idioma';
import { IdiomaCalendario } from '../../domain/IdiomaCalendatio';
import { IdiomaService } from '../../providers/idioma/idioma.service';
import { EntityManagerProvider } from '../../providers/entity-manager-provider/entity-manager-provider';

@Component({
  selector: 'app-selector-idioma',
  templateUrl: './selectorIdioma.component.html',
  styleUrls: ['./selectorIdioma.component.scss']
})

// No se usa
//TODO: Prueba para importar un componente en varios sitios

export class SelectorIdiomaComponent implements OnInit {

	@Output() onIdiomaChange: EventEmitter<any> = new EventEmitter();

	/* IDIOMA */
	idiomas;
	idiomaSeleccionado: Idioma;
	idiomaDefecto: Idioma;
	idiomaCalendario: IdiomaCalendario;

	constructor(
		private entityManager: EntityManagerProvider,
		private idiomaService: IdiomaService
		)
	{
		const that = this;

		this.entityManager.getIDIOMA()
		.then(function (idiomasENTIDAD: any) {
			that.idiomas = [];
			idiomasENTIDAD.forEach(idioma => {

					that.idiomas.push(new Idioma(idioma));

			});

			that.idiomaDefecto = that.idiomaService.getIdiomaDefecto(that.idiomas);
			that.idiomaSeleccionado = that.idiomaDefecto;
		});

	}

	ngOnInit(): void {


	}

	idiomaChange($event){
		this.onIdiomaChange.emit($event);
	}


}



// WEBPACK FOOTER //
// C:/Users/adri9/Escritorio/admin-everpath/src/app/componentes/selectorIdioma/selectorIdioma.component.ts